import { useStage } from './useStage'

export default () => useStage('drivers-license')
